import { buildPath } from "@tecorien/mimic";
import { FleetDto } from "generated/graphql";
import { defaultSerializer, SerializerOptions } from "../index";

export const FleetDtoSerializer = {
  type: "FleetDto",
  serializer: (entity: FleetDto, options: SerializerOptions): Partial<FleetDto> | null => {
    const serialized = defaultSerializer(entity, options) as any;
    if (serialized) {
      delete serialized[buildPath<FleetDto>()("users").toString()]
      delete serialized[buildPath<FleetDto>()("name").toString()]
      delete serialized[buildPath<FleetDto>()("shortName").toString()]
      delete serialized[buildPath<FleetDto>()("legacyCompanyId").toString()]
      delete serialized[buildPath<FleetDto>()("companyRepresentativeUser").toString()]
      delete serialized[buildPath<FleetDto>()("attachments").toString()]
      delete serialized[buildPath<FleetDto>()("entityAttachmentPreviews").toString()]
      delete serialized[buildPath<FleetDto>()("entityAttachmentTotal").toString()]
      delete serialized[buildPath<FleetDto>()("verifications").toString()]
    }
    return serialized;
  },
};
